/// <amd-module name="Wit/Common/WitSettingsViews/Components/CardSettingsViews/BoardFieldSettingsConstants" />
import { CoreFieldRefNames } from "Wit/Common/Generated/Constants";

export const DefaultBoardsCoreFieldSettings = [CoreFieldRefNames.AssignedTo, CoreFieldRefNames.Id, CoreFieldRefNames.Tags];

export namespace FieldSettingKeys {
    export const FieldIdentifier = "fieldIdentifier";
    export const DisplayType = "displayType";
    export const ShowEmptyFields = "showEmptyFields";
}
